export default __webpack_public_path__ + "images/commercial-icon@2x.png?6c725391bb2da816c372bea6876e081e";